// Native JS utilities to replace lodash
// Replace lodash cloneDeep with structuredClone (native)
const cloneDeep = (obj)=>{
    if (typeof structuredClone !== 'undefined') {
        return structuredClone(obj);
    }
    // Fallback for environments without structuredClone
    return JSON.parse(JSON.stringify(obj));
};
// Replace lodash keyBy with native reduce
const keyBy = (array, key)=>{
    return array.reduce((acc, item)=>{
        const keyValue = item[key];
        // Skip nullish or dangerous keys
        if (keyValue == null || typeof keyValue === 'string' && (keyValue === '__proto__' || keyValue === 'constructor' || keyValue === 'prototype' || keyValue.startsWith('__proto__') || keyValue.startsWith('constructor') || keyValue.startsWith('prototype'))) {
            return acc;
        }
        // Coerce key to string and assign
        const safeKey = String(keyValue);
        acc[safeKey] = item;
        return acc;
    }, Object.create(null));
};
// Safe JSON parse utility
const safeParse = (jsonString, fallback)=>{
    try {
        if (!jsonString) return fallback;
        return JSON.parse(jsonString);
    } catch (error) {
        return fallback;
    }
};

export { cloneDeep, keyBy, safeParse };
//# sourceMappingURL=utils.js.map
